const doLog = function(type, message, data) {
  let ref
  return (data = {
    data,
    account: (ref = window.app.user) != null ? ref.account : void 0,
  })
}

// app.service('logger').create {type, message, data}
export default {
  config(app) {
    let i, len, method, ref, results
    window.onerror = (message, source, lineno, colno, error) => {
      this.error({ message, source, lineno, colno, error })
      return true
    }
    ref = ['info', 'warn', 'error']
    results = []
    for (i = 0, len = ref.length; i < len; i++) {
      method = ref[i]
      results.push((app[method] = this[method]))
    }
    return results
  },
  info(message, opts) {
    return doLog('info', message, opts)
  },
  warn(message, opts) {
    console.warn(message, opts)
    return doLog('warn', message, opts)
  },
  error(message, opts) {
    console.error(message, opts)
    return doLog('error', message, opts)
  },
}
